<input *ngIf="!disabled" 
  type="text"
  pInputText [(ngModel)]="value"
  (blur)="onBlur($event)"
  [ngClass]="isValid ? 'p-inputtext' : 'p-inputtext-invalid'"
/>

<span *ngIf="disabled" class="text-600">{{value}}</span>
